import React, { Component } from 'react';
import { translate } from 'react-i18next';
import brandLogo from '../../images/brand-logo-inverse-dark.png';
import { checkPassword } from "../../helpers/passwordUtils";
import Input from '../../components/Input'

class PasswordChange extends Component {
  state = {
    password: this.props.password || '',
    passwordConfirm: this.props.passwordConfirm || '',
    passwordVerification: {
      uppercase: false,
      lowercase: false,
      digits: false,
      specialChar: false,
      minLength: false,
      noSpaces: true,
      isValid: false,
    },
  };

  handlePassword = (e) => {
    const pass = e.target.value;
    const verification = checkPassword(pass, { minLength: 8 }); 
    this.setState({
      password: pass,
      passwordVerification: verification,
    });

    if (this.props.handlePasswordChange) {
      this.props.handlePasswordChange(e, verification);
    }
  };

  handlePasswordConfirm = (e) => {
    const val = e.target.value;
    this.setState({ passwordConfirm: val });
    if (this.props.handlePasswordConfirm) this.props.handlePasswordConfirm(e);
  };

  render() {
    const t = this.props.t || ((x) => x);
    const { passwordVerification, password, passwordConfirm } = this.state;

    const check = <i className="fa-solid fa-check text-success" />;
    const incorrect = <i className="fa-solid fa-xmark error-text" />;

    const canSubmit =
      passwordVerification.isValid && passwordConfirm === password;

    return (
      <div>
        <button
          className="hidden"
          data-target="#PassworChange"
          data-toggle="modal"
          id="btnPassworChange"
          type="button"
        />
        <div className="modal fade" id="PassworChange" role="dialog" style={{ textAlign: 'left' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                  <span className="modal-title h4">
                    {/* <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} /> */}
                    {t('guest.password.change_password')}
                  </span>
              </div>
              <div className="modal-body">
                <form className="form-horizontal" method="post" onSubmit={(e)=>e.preventDefault()}>

                        <div className="form-group">
                          <label className="col-sm-4 control-label" htmlFor="password" style={{height: "42px", alignContent: "center"}}>
                            {t('guest.password.label_password')}
                          </label>
                          <div className="col-sm-7">
                            <Input
                              className="form-control"
                              id="password"
                              type="password"
                              value={password}
                              onChange={this.handlePassword}
                              required
                              autoComplete="new-password"
                            />
                          </div>
                        </div>
                  
                  <div className="col-md-11 col-md-offset-1">
                    {/* <p>{t('guest.password.security')}</p> */}
                    <div style={{ textAlign: 'left' }}>
                      <h5>{t('onboarding.signup.pass_requirements_text')}</h5>
                      <ul>
                        <li>
                          {t('onboarding.signup.pass_requirements.length')}{' '}
                          {passwordVerification.minLength ? check : incorrect}
                        </li>
                        <li>
                          {t('onboarding.signup.pass_requirements.uppercase')}{' '}
                          {passwordVerification.uppercase ? check : incorrect}
                        </li>
                        <li>
                          {t('onboarding.signup.pass_requirements.lowercase')}{' '}
                          {passwordVerification.lowercase ? check : incorrect}
                        </li>
                        <li>
                          {t('onboarding.signup.pass_requirements.number')}{' '}
                          {passwordVerification.digits ? check : incorrect}
                        </li>
                        <li>
                          {t('onboarding.signup.pass_requirements.special')}{' '}
                          {passwordVerification.specialChar ? check : incorrect}
                        </li>
                      </ul>
                    </div>
                  </div>        

                        <div className="form-group">
                          <label className="col-sm-4 control-label" htmlFor="passwordConfirm" style={{height: "42px", alignContent: "center"}}>
                            {t('guest.password.label_pwdconfirm')}
                          </label>
                          <div className="col-sm-7">
                            <Input
                              className="form-control"
                              id="passwordConfirm"
                              type="password"
                              value={passwordConfirm}
                              onChange={this.handlePasswordConfirm}
                              required
                              autoComplete="new-password"
                            />
                          </div>
                        </div>
                        
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">
                  {t('dashboard.profile.btn_close_balance')}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.props.handlePasswordSubmit}
                  disabled={!canSubmit}
                  title={!canSubmit ? t('onboarding.signup.pass_requirements_text') : undefined}
                >
                  {t('guest.password.btn_submit')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(PasswordChange);


// WEBPACK FOOTER //
// ./src/dashboard/profile/PasswordChange.js